import { render, staticRenderFns } from "./Inner.vue?vue&type=template&id=bbbecd8a&"
import script from "./Inner.vue?vue&type=script&lang=js&"
export * from "./Inner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Inner.vue"
export default component.exports